export function PageLoader() {
  return (
    <main className="status-shell" aria-busy="true" aria-live="polite">
      <div className="route-loader" aria-hidden="true" />
      <p>Preparando sua experiência CONAN…</p>
    </main>
  );
}
